import { NotFoundPageLabels } from 'libs/shared-lib/interfaces/partner-web/not-found-page';

export const NOT_FOUND_LABELS_DE: NotFoundPageLabels = {
    headline: '404',
    copy: 'Die von Ihnen angeforderte Seite existiert leider nicht.',
    ctaPostText: 'Weiter zu',
};
